import styled from "styled-components";
import { Link } from "react-router-dom";

export const Wrapper = styled.div`
  position: absolute;
  top: 60px;
  left: 0;
  height: 100vh;
    padding:10px;
    background-color: var(--lightGrey);
    width: ${({ open }) => (open ? "300px" : "30px")};
   
  transition: width 0.3s ease-in-out;
  
`
export const Burger = styled.div`
position: fixed;
  top: 70px;
  cursor: pointer;
  padding: 10px;
  z-index: 1000;
  
  display: ${({ open }) => (open ? "none" : "block")}; 
`

export const Content = styled.div`

    padding:10px;
    opacity: ${({ open }) => (open ? "1" : "0")};
    transition: opacity 0.2s ease-in-out;

`